export const Domain = "https://servicure-backend.deveshjain.repl.co/api/"